@use '@lib/assets/styles/main.scss' as *;

.topHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  & > * {
    max-width: 100%;
    min-width: 0;
  }
}

.header {
  display: grid;
  grid-template-columns: auto min-content;
  grid-column-gap: 16px;
}

.headerActions {
  display: flex;
  gap: 16px;
  align-self: flex-start;
}

.title {
  word-break: break-word;
  padding-top: 4px;
}

.infoList {
  margin: 32px 0;
}

.infoListTitle {
  padding-bottom: 16px;
  &.hasTopSpace {
    margin-top: 48px;
  }
}

.infoItem {
  &:not(.block) {
    display: grid;
    grid-template-columns: min-content auto;
    grid-gap: 16px;
  }
  &:not(.infoItemCentered) {
    align-items: flex-start;
  }
  &.infoItemCentered {
    align-items: center;
  }
  &.nowrap {
    white-space: nowrap;
  }
  &:not(.infoItemWithLabelIcon) {
    & + .infoItem {
      margin-top: 16px;
    }
  }
  &.infoItemWithLabelIcon {
    & + .infoItemWithLabelIcon {
      margin-top: 12px;
    }
  }
}

.infoItemCol {
  display: grid;
  grid-row-gap: 8px;
}

.infoItemCol + .infoItemCol,
.infoItem + .infoItemCol,
.infoItemCol + .infoItem {
  @include responsive($md1) {
    margin-top: 16px;
  }
  @include responsive(null, $md1) {
    margin-top: 24px;
  }
}

// Content block for components
.infoItemContentBox {
  min-height: 32px;
  display: flex;
  align-items: center;
  max-width: 100%;
  gap: 8px;

  & > * {
    max-width: 100%;
  }
}

// Content block for text
.infoItemContent {
  min-height: 32px;
  display: flex;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  & > * {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.infoItemMessage {
  grid-column: 1 / 3;
}

.infoItemContentFullWidth {
  width: 100%;
}

.infoItemContentRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.infoItemHeader {
  display: grid;
  grid-template-columns: auto min-content;
  align-items: center;
}

.infoItemLabel {
  color: $gray500;
  min-width: 152px;
  display: grid;
  grid-template-columns: 24px auto;
  grid-column-gap: 12px;
  align-items: center;
  min-height: 32px;
  .block & {
    margin-bottom: 8px;
  }
}

.infoItemLabelWithoutIcon {
  color: $gray500;
  width: 152px;
  display: grid;
  align-items: center;
  min-height: 32px;
}

.infoItemIconLabel {
  color: $gray500;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 24px;
  min-height: 24px;
}

.infoItemTitle {
  color: $gray500;
  display: grid;
  grid-template-columns: 24px auto;
  grid-column-gap: 12px;
  align-items: center;
  min-height: 32px;
}

.infoItemTitleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.infoItemLabelText {
  display: flex;
  align-items: center;
  gap: 4px;
}

.description {
  color: $gray500;
  width: 100%;
  word-break: break-word;
  padding-top: 8px;
  padding-left: 36px;
}

.textEditor {
  width: 100%;
  padding: 16px;
  border: 1px solid $gray100;
  border-radius: 6px;
}

.actions {
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

// Other
.hrLine {
  border: none;
  padding: 0;
  margin: 24px -24px;
  background-color: $gray200;
  height: 1px;
}

.deactivatedOpacity {
  @extend %disabledGrayscale;
}
